import { defineStore } from 'pinia'

interface State {
  action: any,
  hasUnread: boolean,
}

export default defineStore('notifications', {
  state: (): State => ({
    action: {},
    hasUnread: false,
  }),
  actions: {
    setHasUnread(value: boolean) {
      this.hasUnread = value
    },
    setNotificationAction(action?: any) {
      this.action = action
    },
  }
})
